import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import MarketingTemplatesCreate from './create';
import MarketingTemplatesList from './contents/MarketingTemplatesList';
import { isMarketingTemplatesNewSelectorPath } from './marketingTemplatesPaths';

const TemplatesContent = memo(({ onOpenHtmlEditor, onOpenVisualEditor }) => {
    const { pathname } = useLocation();

    let body;
    if (isMarketingTemplatesNewSelectorPath(pathname)) {
        body = (
            <MarketingTemplatesCreate
                onOpenHtmlEditor={onOpenHtmlEditor}
                onOpenVisualEditor={onOpenVisualEditor}
            />
        );
    } else {
        body = (
            <MarketingTemplatesList
                onOpenHtmlEditor={onOpenHtmlEditor}
                onOpenVisualEditor={onOpenVisualEditor}
            />
        );
    }

    return <div className="marketing-templates__wrapper">{body}</div>;
});

TemplatesContent.displayName = 'TemplatesContent';

TemplatesContent.propTypes = {
    onOpenHtmlEditor: PropTypes.func,
    onOpenVisualEditor: PropTypes.func,
};

export default TemplatesContent;
